import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SharedState} from "./shared.reducer";

const getSharedState = createFeatureSelector<SharedState>('shared');

export const getSharedSuccess = createSelector(getSharedState, (state: SharedState) => state.success);

export const getUserMeasurements = createSelector(getSharedState, (state: SharedState) => state.measurements);
export const getCurrencyData = createSelector(getSharedState, (state: SharedState) => state.currencyData);
